var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMaskIcon = function SvgMaskIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M21.194 38.066a1.655 1.655 0 0 0-3.31 0v8.28a1.655 1.655 0 0 0 3.31 0v-8.28z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M21.194 38.066a1.655 1.655 0 0 0-3.31 0v8.28a1.655 1.655 0 0 0 3.31 0v-8.28z",
    fill: "url(#mask-icon_svg__a)",
    fillOpacity: 0.19
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.194 44.69a1.655 1.655 0 0 0-3.31 0v1.655a1.655 1.655 0 0 0 3.31 0V44.69z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.194 44.69a1.655 1.655 0 0 0-3.31 0v1.655a1.655 1.655 0 0 0 3.31 0V44.69z",
    fill: "url(#mask-icon_svg__b)",
    fillOpacity: 0.19
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.468 38.066a1.656 1.656 0 0 0-2.825-1.17 1.656 1.656 0 0 0-.484 1.17v8.28a1.655 1.655 0 0 0 3.31 0v-8.28z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.468 38.066a1.656 1.656 0 0 0-2.825-1.17 1.656 1.656 0 0 0-.484 1.17v8.28a1.655 1.655 0 0 0 3.31 0v-8.28z",
    fill: "url(#mask-icon_svg__c)",
    fillOpacity: 0.19
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.522 1.25 3.294 33.105a2.197 2.197 0 0 0 2.54 3.202l16.755-6.403a3.617 3.617 0 0 1 2.177 0l16.755 6.403a2.196 2.196 0 0 0 2.54-3.202L25.832 1.25a2.482 2.482 0 0 0-4.31 0z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.522 1.25 3.294 33.105a2.197 2.197 0 0 0 2.54 3.202l16.755-6.403a3.617 3.617 0 0 1 2.177 0l16.755 6.403a2.196 2.196 0 0 0 2.54-3.202L25.832 1.25a2.482 2.482 0 0 0-4.31 0z",
    fill: "url(#mask-icon_svg__d)",
    fillOpacity: 0.19
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mask-icon_svg__a",
    x1: 19.539,
    y1: 36.412,
    x2: 19.539,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mask-icon_svg__b",
    x1: 19.539,
    y1: 43.035,
    x2: 19.539,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mask-icon_svg__c",
    x1: 27.814,
    y1: 36.412,
    x2: 27.814,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mask-icon_svg__d",
    x1: 23.678,
    y1: -0.002,
    x2: 23.678,
    y2: 36.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};

export default SvgMaskIcon;